import '.e0{padding-block:0.5rem;}.ssr-plugin'
import '.e1{border-radius:0.5rem;}.ssr-plugin'
import '.c4{border:none;}.ssr-plugin'
import '.a1{cursor:pointer;}.ssr-plugin'
import '.dp{user-select:none;}.ssr-plugin'
import '.av{flex:1;}.ssr-plugin'
import Row from '@app/components/layout/Row'
import { Style, styled } from 'inlines'
import { Text } from '../typography/Text'

export type ToggleOption<T> = {
  label: string
  value: T
  style?: Style
}

export type ToggleProps<T> = {
  options: ToggleOption<T>[]
  selectedOption: T
  setSelectedOption: (option: T) => void
  style?: Style
}

export const Toggle = <T extends string | boolean>({
  options,
  selectedOption,
  setSelectedOption,
  style,
}: ToggleProps<T>) => {
  return (
    <Row
      alignItems="center"
      gap={'0.5rem'}
      style={{
        alignSelf: 'flex-start',
        padding: '0.25rem',
        background: 'var(--palette-blue-50)',
        borderRadius: '0.75rem',
        cursor: 'pointer',
        ...style,
      }}
    >
      {options.map((option, i) => (
        <styled.button className="e0 e1 c4 a1 dp av"
          key={i}
          type="button"
          onClick={() => setSelectedOption(option.value)}
          style={{
            backgroundColor:
              selectedOption === option.value
                ? 'var(--palette-white)'
                : 'transparent',
            boxShadow:
              selectedOption === option.value
                ? '0 3px 10px 0 rgba(0, 0, 0, 0.05)'
                : 'none',
            ...option.style,
          }}
        >
          <Text.Medium
            color={
              selectedOption === option.value
                ? 'var(--brand-secondary)'
                : 'var(--palette-blue-400)'
            }
          >
            {option.label}
          </Text.Medium>
        </styled.button>
      ))}
    </Row>
  )
}
